/**
 * Static catalogue of services for BIONET SOLUTIONS
 * 11 categories with full prestation lists (FR + EN keys).
 */
import {
  Sparkles,
  Flame,
  Trash2,
  Home,
  Building2,
  Building,
  HardHat,
  Layers,
  TreePine,
  Wind,
  Leaf,
  Sofa,
  LayoutGrid,
  GlassWater,
} from "lucide-react";

export const SERVICE_CATEGORIES = [
  {
    slug: "extreme",
    icon: Sparkles,
    accent: "from-emerald-50 to-emerald-100/50",
    items: {
      fr: [
        "Nettoyage après décès",
        "Nettoyage après suicide",
        "Nettoyage après homicide",
        "Nettoyage après découverte tardive de corps",
        "Désinfection de logement",
        "Nettoyage syndrome de Diogène",
        "Nettoyage de logement insalubre",
        "Nettoyage après squat",
        "Décontamination",
        "Traitement des odeurs",
        "Désinfection après nuisibles",
        "Nettoyage après désinsectisation",
        "Nettoyage après dératisation",
        "Nettoyage de fientes de pigeons",
        "Remise en état de logement très sale",
      ],
      en: [
        "After-death cleaning",
        "Post-suicide cleaning",
        "Post-homicide cleaning",
        "Late discovery of body cleaning",
        "Home disinfection",
        "Diogenes syndrome cleaning",
        "Unsanitary housing cleaning",
        "Post-squat cleaning",
        "Decontamination",
        "Odour treatment",
        "Post-pest disinfection",
        "Post-disinsectisation cleaning",
        "Post-deratisation cleaning",
        "Pigeon droppings cleaning",
        "Restoration of very dirty housing",
      ],
    },
  },
  {
    slug: "sinistre",
    icon: Flame,
    accent: "from-blue-50 to-cyan-50",
    items: {
      fr: [
        "Nettoyage après incendie",
        "Nettoyage après dégât des eaux",
        "Nettoyage après inondation",
        "Nettoyage après vandalisme",
        "Nettoyage après catastrophe naturelle",
        "Nettoyage de suie",
        "Décontamination après sinistre",
        "Nettoyage de poudre d'extincteur",
        "Remise en état après sinistre",
        "Intervention urgente",
      ],
      en: [
        "Post-fire cleaning",
        "Post-water damage cleaning",
        "Post-flood cleaning",
        "Post-vandalism cleaning",
        "Post-natural disaster cleaning",
        "Soot cleaning",
        "Post-disaster decontamination",
        "Fire extinguisher powder cleaning",
        "Post-disaster restoration",
        "Emergency intervention",
      ],
    },
  },
  {
    slug: "debarras",
    icon: Trash2,
    accent: "from-slate-50 to-slate-100/60",
    items: {
      fr: [
        "Débarras de maison",
        "Débarras d'appartement",
        "Débarras de cave",
        "Débarras de garage",
        "Débarras de grenier",
        "Débarras après décès",
        "Débarras après succession",
        "Débarras de logement insalubre",
        "Débarras après syndrome de Diogène",
        "Débarras de bureaux",
        "Débarras de locaux professionnels",
        "Évacuation d'encombrants",
        "Évacuation de gravats",
        "Tri, manutention et nettoyage après débarras",
      ],
      en: [
        "House clearance",
        "Apartment clearance",
        "Cellar clearance",
        "Garage clearance",
        "Attic clearance",
        "Post-mortem clearance",
        "Estate clearance",
        "Unsanitary housing clearance",
        "Post-Diogenes clearance",
        "Office clearance",
        "Professional premises clearance",
        "Bulky waste removal",
        "Rubble removal",
        "Sorting, handling and post-clearance cleaning",
      ],
    },
  },
  {
    slug: "particuliers",
    icon: Home,
    accent: "from-emerald-50 to-blue-50",
    items: {
      fr: [
        "Ménage à domicile",
        "Nettoyage ponctuel",
        "Nettoyage régulier",
        "Nettoyage de printemps",
        "Grand nettoyage de maison",
        "Grand nettoyage d'appartement",
        "Nettoyage avant déménagement",
        "Nettoyage après déménagement",
        "Nettoyage de salle de bain",
        "Nettoyage de cuisine",
        "Nettoyage de vitres à domicile",
        "Lessivage de murs et plafonds",
        "Nettoyage de carrelage et joints",
        "Nettoyage de terrasse / balcon",
        "Nettoyage après soirée privée",
        "Nettoyage de bateau",
        "Nettoyage automobile à domicile",
      ],
      en: [
        "Home cleaning",
        "One-off cleaning",
        "Regular cleaning",
        "Spring cleaning",
        "Deep house cleaning",
        "Deep apartment cleaning",
        "Pre-move cleaning",
        "Post-move cleaning",
        "Bathroom cleaning",
        "Kitchen cleaning",
        "Home window cleaning",
        "Walls and ceilings washing",
        "Tiles and joints cleaning",
        "Terrace / balcony cleaning",
        "Post-party cleaning",
        "Boat cleaning",
        "On-site car cleaning",
      ],
    },
  },
  {
    slug: "professionnels",
    icon: Building2,
    accent: "from-cyan-50 to-blue-50",
    items: {
      fr: [
        "Nettoyage de bureaux",
        "Entretien de locaux professionnels",
        "Nettoyage de commerces",
        "Nettoyage de magasins",
        "Nettoyage de centres commerciaux",
        "Nettoyage industriel",
        "Nettoyage d'entrepôts",
        "Nettoyage de hangars",
        "Nettoyage d'ateliers",
        "Nettoyage de parkings",
        "Nettoyage événementiel",
        "Nettoyage de cuisines professionnelles",
        "Nettoyage de restaurants",
        "Nettoyage de hottes de cuisine",
        "Lavage de vitres de bureaux",
        "Destruction d'archives",
      ],
      en: [
        "Office cleaning",
        "Professional premises maintenance",
        "Retail cleaning",
        "Shop cleaning",
        "Mall cleaning",
        "Industrial cleaning",
        "Warehouse cleaning",
        "Hangar cleaning",
        "Workshop cleaning",
        "Car park cleaning",
        "Event cleaning",
        "Pro kitchen cleaning",
        "Restaurant cleaning",
        "Kitchen hood cleaning",
        "Office window cleaning",
        "Archive destruction",
      ],
    },
  },
  {
    slug: "immeubles",
    icon: Building,
    accent: "from-slate-50 to-blue-50",
    items: {
      fr: [
        "Nettoyage d'immeubles",
        "Entretien de parties communes",
        "Nettoyage de halls d'entrée",
        "Nettoyage d'escaliers",
        "Nettoyage d'ascenseurs",
        "Nettoyage de locaux poubelles",
        "Sortie et rentrée des containers",
        "Nettoyage de parkings de copropriété",
        "Nettoyage de vitres d'immeubles",
        "Nettoyage après travaux en copropriété",
        "Remise en état des parties communes",
      ],
      en: [
        "Building cleaning",
        "Common areas maintenance",
        "Lobby cleaning",
        "Staircase cleaning",
        "Elevator cleaning",
        "Bin room cleaning",
        "Container in/out service",
        "Condo car park cleaning",
        "Building window cleaning",
        "Post-works cleaning",
        "Common areas restoration",
      ],
    },
  },
  {
    slug: "chantier",
    icon: HardHat,
    accent: "from-amber-50 to-emerald-50",
    items: {
      fr: [
        "Nettoyage fin de chantier",
        "Nettoyage après travaux",
        "Dépoussiérage complet",
        "Enlèvement des traces de peinture",
        "Nettoyage des sols",
        "Nettoyage des vitres",
        "Nettoyage des sanitaires",
        "Remise en état avant livraison",
        "Nettoyage après rénovation",
      ],
      en: [
        "Post-construction cleaning",
        "Post-work cleaning",
        "Full dusting",
        "Paint marks removal",
        "Floor cleaning",
        "Window cleaning",
        "Sanitary cleaning",
        "Pre-delivery restoration",
        "Post-renovation cleaning",
      ],
    },
  },
  {
    slug: "sols",
    icon: Layers,
    accent: "from-blue-50 to-emerald-50",
    items: {
      fr: [
        "Nettoyage professionnel des sols",
        "Décapage des sols",
        "Lavage mécanisé",
        "Nettoyage de moquettes",
        "Nettoyage de tapis",
        "Nettoyage de carrelage",
        "Nettoyage des joints",
        "Ponçage et rénovation de marbre",
        "Rénovation de parquet",
        "Métallisation des sols",
        "Entretien des surfaces sensibles",
      ],
      en: [
        "Professional floor cleaning",
        "Floor stripping",
        "Mechanical washing",
        "Carpet cleaning",
        "Rug cleaning",
        "Tile cleaning",
        "Joints cleaning",
        "Marble polishing",
        "Parquet restoration",
        "Floor metallisation",
        "Sensitive surfaces maintenance",
      ],
    },
  },
  {
    slug: "exterieur",
    icon: Wind,
    accent: "from-cyan-50 to-emerald-50",
    items: {
      fr: [
        "Nettoyage de toiture",
        "Nettoyage de gouttières",
        "Démoussage toiture",
        "Nettoyage de façades",
        "Nettoyage de bardages",
        "Nettoyage de façade commerciale",
        "Nettoyage d'enseigne",
        "Nettoyage de graffitis",
        "Nettoyage de panneaux solaires",
        "Nettoyage de terrasses",
        "Nettoyage de mobilier urbain",
        "Nettoyage de piscines",
        "Nettoyage d'abris de piscine",
        "Nettoyage de serres",
        "Entretien des berges et cours d'eau",
        "Nettoyage d'ouvrages d'art",
      ],
      en: [
        "Roof cleaning",
        "Gutter cleaning",
        "Roof moss removal",
        "Facade cleaning",
        "Cladding cleaning",
        "Commercial facade cleaning",
        "Signage cleaning",
        "Graffiti cleaning",
        "Solar panel cleaning",
        "Terrace cleaning",
        "Urban furniture cleaning",
        "Pool cleaning",
        "Pool enclosure cleaning",
        "Greenhouse cleaning",
        "Riverbank maintenance",
        "Engineering structures cleaning",
      ],
    },
  },
  {
    slug: "espaces_verts",
    icon: TreePine,
    accent: "from-emerald-50 to-emerald-100/40",
    items: {
      fr: [
        "Élagage d'arbres",
        "Abattage d'arbres",
        "Débroussaillage",
        "Dessouchage",
        "Taille de haies",
        "Nettoyage et remise en état de terrain",
      ],
      en: [
        "Tree pruning",
        "Tree felling",
        "Brush clearing",
        "Stump removal",
        "Hedge trimming",
        "Land cleaning and restoration",
      ],
    },
  },
  {
    slug: "batiments",
    icon: Leaf,
    accent: "from-slate-50 to-emerald-50",
    items: {
      fr: [
        "Nettoyage de bâtiments anciens",
        "Nettoyage de monuments",
        "Nettoyage VMC",
        "Nettoyage de conduits de ventilation",
        "Ramonage",
        "Traitement de l'humidité",
        "Traitement des moisissures",
        "Traitement des odeurs",
        "Traitement du bois de charpente",
        "Traitement des remontées capillaires",
        "Nettoyage de bâtiments agricoles",
      ],
      en: [
        "Old buildings cleaning",
        "Monument cleaning",
        "HVAC cleaning",
        "Ventilation duct cleaning",
        "Chimney sweeping",
        "Humidity treatment",
        "Mould treatment",
        "Odour treatment",
        "Roof timber treatment",
        "Capillary rising treatment",
        "Agricultural buildings cleaning",
      ],
    },
  },
  {
    slug: "canapes",
    icon: Sofa,
    accent: "from-rose-50 to-amber-50",
    items: {
      fr: [
        "Nettoyage de canapés en tissu",
        "Nettoyage de canapés en cuir",
        "Nettoyage de fauteuils",
        "Nettoyage de sièges et chaises rembourrées",
        "Nettoyage de têtes de lit et sommiers tapissés",
        "Nettoyage de coussins décoratifs",
        "Détachage tissu d'ameublement",
        "Traitement anti-acariens et anti-allergènes",
        "Traitement anti-odeurs (tabac, animaux, moisissures)",
        "Imperméabilisation tissus",
        "Nettoyage à la vapeur",
        "Extraction à sec sur tissus délicats",
        "Nettoyage de tissu velours, microfibre, lin",
        "Nettoyage de matelas à domicile",
        "Remise en état ameublement après dégât des eaux",
      ],
      en: [
        "Fabric sofa cleaning",
        "Leather sofa cleaning",
        "Armchair cleaning",
        "Upholstered seats and chairs cleaning",
        "Upholstered headboards and bases cleaning",
        "Decorative cushion cleaning",
        "Upholstery stain removal",
        "Anti-mite and anti-allergen treatment",
        "Odour treatment (smoke, pets, mould)",
        "Fabric waterproofing",
        "Steam cleaning",
        "Dry extraction for delicate fabrics",
        "Velvet, microfibre, linen fabric cleaning",
        "Mattress cleaning at home",
        "Upholstery restoration after water damage",
      ],
    },
  },
  {
    slug: "tapis",
    icon: LayoutGrid,
    accent: "from-violet-50 to-indigo-50",
    items: {
      fr: [
        "Nettoyage de tapis à domicile",
        "Nettoyage de moquettes murales",
        "Nettoyage de moquettes collées",
        "Détachage tapis et moquettes",
        "Nettoyage tapis d'Orient et tapis anciens",
        "Nettoyage tapis berbère et laine",
        "Nettoyage tapis synthétique et vinyle",
        "Extraction à injection-extraction",
        "Nettoyage vapeur tapis",
        "Traitement anti-acariens",
        "Traitement anti-taches permanent",
        "Traitement anti-odeurs",
        "Nettoyage moquette hôtel et établissements publics",
        "Nettoyage moquette bureaux",
        "Remise en état tapis après dégât des eaux",
      ],
      en: [
        "Rug cleaning at home",
        "Wall-to-wall carpet cleaning",
        "Glued carpet cleaning",
        "Rug and carpet stain removal",
        "Oriental and antique rug cleaning",
        "Berber and wool rug cleaning",
        "Synthetic and vinyl carpet cleaning",
        "Injection-extraction cleaning",
        "Steam carpet cleaning",
        "Anti-mite treatment",
        "Permanent stain protection",
        "Odour treatment",
        "Hotel and public venue carpet cleaning",
        "Office carpet cleaning",
        "Rug restoration after water damage",
      ],
    },
  },
  {
    slug: "vitres",
    icon: GlassWater,
    accent: "from-sky-50 to-cyan-50",
    items: {
      fr: [
        "Lavage de vitres à domicile",
        "Nettoyage vitres intérieures et extérieures",
        "Nettoyage de baies vitrées",
        "Nettoyage de vérandas et verrières",
        "Nettoyage de Velux et fenêtres de toit",
        "Nettoyage de vitres d'immeubles",
        "Nettoyage de vitrines commerciales",
        "Nettoyage de miroirs",
        "Nettoyage de cloisons vitrées en bureau",
        "Nettoyage de puits de lumière",
        "Dégraissage cadres et encadrements",
        "Traitement anti-calcaire vitres",
        "Traitement anti-rayures",
        "Nettoyage façade vitrée haute",
        "Nettoyage vitres après chantier",
      ],
      en: [
        "Home window cleaning",
        "Interior and exterior window cleaning",
        "French door and sliding door cleaning",
        "Conservatory and glass roof cleaning",
        "Skylight and roof window cleaning",
        "Building window cleaning",
        "Shop window cleaning",
        "Mirror cleaning",
        "Office glass partition cleaning",
        "Atrium and light well cleaning",
        "Frame and sill degreasing",
        "Anti-limescale window treatment",
        "Anti-scratch treatment",
        "High glazed facade cleaning",
        "Post-construction window cleaning",
      ],
    },
  },
];

export const PARTNERS = [
  { name: "Foncia",                 logo: "/foncia.png" },
  { name: "Picard Services",        logo: "/picard.png" },
  { name: "Albaron",                logo: "/albaron.jpg" },
  { name: "Relay Gare",             logo: "/relay.png" },
  { name: "Lyon Métropole Habitat", logo: "/logo-metropole-grand-lyon.jpg" },
  { name: "Alliade Habitat",        logo: "/alliade.png" },
  { name: "Aquavert",               logo: "/aquavert.jpg" },
  { name: "Pandora",                logo: "/pandora.png" },
  { name: "Eiffage Énergie",        logo: "/eiffage.png" },
  { name: "Novotel",                logo: "/novotel.png" },
  { name: "Maaf",                   logo: "/logo-vectoriel-maaf.jpg" },
];
